module.exports = __webpack_public_path__ + "img/top-explanation02.afe77a04.png";